var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":true,"max-width":"500px"}},[_c('v-card',[_c('v-card-text',[_c('v-select',{attrs:{"label":_vm.$t('item'),"items":_vm.items,"item-value":"uuid","item-text":"title"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }